import { FC, ReactNode } from 'react';
import { useSidebarState } from 'react-admin';
import Header from './Header';
import Sidebar from './Sidebar';
import { Box, GlobalStyles, useTheme } from '@mui/material';
import { brandGlobalStyles } from '../themes/brandTheme';
import Footer from '../components/Footer';
import { Padding } from '@mui/icons-material';
import { AccountProjectProvider } from '../contexts/AccountProjectContext';
interface BaseLayoutProps {
  children?: ReactNode;
}

const BaseLayout: FC<BaseLayoutProps> = ({ children }) => {
  return (
    <Box
      sx={{
        flex: 1,
        height: '100%'
      }}
    >
      {children}
    </Box>
  );
};


const CoinhouseSolutionsAdminLayout = ({
  children,
  dashboard,
  title,
}) => {
  const [open] = useSidebarState();
  const theme = useTheme();

  return (
    <AccountProjectProvider>
      <GlobalStyles styles={brandGlobalStyles} />
      <Box
        sx={{
          flex: 1,
          height: '100%',

          '.MuiPageTitle-wrapper': {
            background: 'transparent',
            marginBottom: `${theme.spacing(2)}`,
            boxShadow: 'none'
          }
        }}
      >
        <Header />
        <Sidebar />
        <Box
          sx={{
            position: 'relative',
            zIndex: 5,
            display: 'block',
            flex: 1,
            pt: `${theme.header.height}`,
            [theme.breakpoints.up('lg')]: {
              ml: `${theme.sidebar.width}`
            },
            backgroundColor: theme.palette.background.default,
            paddingBottom: '2.5rem'
          }}
        >
          {children}
          <Footer/>
        </Box>
      </Box>
    </AccountProjectProvider>
  );
};


CoinhouseSolutionsAdminLayout.propTypes = {
  //    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  //    dashboard: PropTypes.oneOfType([
  //        PropTypes.func,
  //        PropTypes.string,
  //    ]),
  //    title: PropTypes.string.isRequired,
};

export default CoinhouseSolutionsAdminLayout;
